import React from 'react';
import loadable from '@loadable/component';

import contactPageContent from './contactPageContent.json';
// empavision:ext-multilanguage — translate the hardcoded local page (same as AboutPage)
import { useTranslatedPageContent } from '../../extensions/empavision-enrichments/packages/ext-multilanguage';

const PageBuilder = loadable(() =>
  import(/* webpackChunkName: "PageBuilder" */ '../PageBuilder/PageBuilder')
);

// Hard-coded Contact page (contactPageContent.json), same rationale and shape as
// AboutPage.
//
// Client feedback 2026-09-16, item 8: "Align contact us page to be similar to
// what we have on the PFS Website. So we are introducing a separate page for
// contact us." That page is a set of contact details, not a form, so this one
// is too: the "We'd like to hear from you!" intro, one email address, and the
// "Connect with us online" social links.
//
// Scope is deliberate (client, 2026-09-17): "take only the social links and
// the email from here for contact". So the phone number and the Edina mailing
// address on the PFS page are NOT reproduced, and its three routes (General
// Requests / Volunteer / Media) are collapsed into one — all three quote the
// same address anyway, which is why splitting them added nothing.
//
// The email and the four social URLs were read off
// partnersinfoodsolutions.com/contact-us in a real browser, not guessed.
// Cloudflare obfuscates the address in the served HTML and decodes it in JS,
// so any plain fetch of that page sees "[email protected]" — a scripted
// Playwright visit is what produced `info@partnersinfoodsolutions.com`.
const ContactPage = () => {
  return <PageBuilder pageAssetsData={useTranslatedPageContent(contactPageContent)} />;
};

export default ContactPage;
